<div class="create-role">
    <!-- Form Container -->
    <div class="container-custom">
        <div class="d-flex justify-content-between align-items-center">
            <div>
             <app-breadcrumb [breadcrumbItems]="breadcrumbItems"></app-breadcrumb>
            </div>
            <span class="fa fa-times close_icon" (click)="closeModal()"></span>
        </div>
        <div class="d-flex justify-content-between align-items-center role-header">
            <div>
                <span class="title">Create Tag</span>
            </div>
        </div>
        <div class="my-4">
            <p>Please fill the below information to create a tag.</p>
        </div>
        <!-- Form Fields -->
        <form [formGroup]="tagForm" (ngSubmit)="onSubmit()">
            <div class="row g-3">
                <div class="col-md-12">
                    <label class="form-label">Enter Tag Name*</label>
                    <input type="text" class="form-control" placeholder="Enter Tag Name" formControlName="name">
                    <small *ngIf="tagForm.get('name')?.invalid && tagForm.get('name')?.touched"
                        class="text-danger">
                        <span *ngIf="tagForm.get('name')?.errors?.['required']">Tag name is
                            required.</span>
                        <span *ngIf="tagForm.get('name')?.errors?.['maxlength']">Tag name cannot exceed
                            100 characters.</span>
                    </small>
                </div>
                <div class="col-md-12 mt-5">
                    <label class="form-label">Slug*</label>
                    <input type="text" class="form-control" placeholder="Add Slug"
                        formControlName="slug">
                    <small
                        *ngIf="tagForm.get('description')?.invalid && tagForm.get('description')?.touched"
                        class="text-danger">
                        <span *ngIf="tagForm.get('description')?.errors?.['required']">Slug is
                            required.</span>
                    </small>
                </div>
            </div>

            <!-- Toggles -->
            <!-- <div class="mt-5">
                <div class="d-flex align-items-center mb-2">
                    <label class="form-check-label me-2">Deleted Status</label>
                    <div class="form-check form-switch">
                        <input class="form-check-input " type="checkbox" formControlName="deleted" >
                    </div>
                </div>
            </div> -->

            <!-- Buttons -->
            <div class="footer-buttons mt-5 mb-2">
                <div class="d-flex align-items-center mt-5 gap-3">
                    <button class="btn btn-outline-secondary mt-5" (click)="closeModal()" type="button">Cancel</button>
                    <button class="btn btn-create mt-5" type="submit">Save</button>
                </div>
            </div>
        </form>
    </div>
</div>
